import { Typography } from '@mui/material';

export interface IHelperAction {
  label: string;
  onClick: () => void;
}

export default function FormFieldHelperAction({
  action,
}: {
  action: IHelperAction;
}) {
  return action ? (
    <Typography
      color="primary"
      variant="caption"
      onClick={action.onClick}
      sx={{ cursor: 'pointer', ml: 'auto', mr: 0 }}
    >
      {action.label}
    </Typography>
  ) : null;
}
